import PromoCode from "./pages/PromoCode";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
    return(
        <div className="App">
            <header className="App-header">
                <PromoCode/>
                <ToastContainer pauseOnFocusLoss={false} style={{fontSize:14}} />
            </header>
        </div>
    )
}

export default App;
